import React, { useState } from "react";
import ReactDOM  from 'react-dom/client';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import { AddDepartmentSer } from "./Services/AddDepartmentSer";
import { useNavigate } from "react-router-dom";
import {useEffect} from "react";
import axios from "axios";
const UpdateCompany = () => {
     useEffect(() => {
        const scriptUrls = [
          'assets/js/jquery.min.js',
          'assets/js/bootstrap.bundle.min.js',
          'assets/js/moment.min.js',
          'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
          'assets/vendor/overlay-scroll/custom-scrollbar.js',
          'assets/vendor/daterange/daterange.js',
          'assets/vendor/daterange/custom-daterange.js',
          'assets/js/custom.js'
        ];
    
        let isCancelled = false;
    
        // Load scripts sequentially
        const loadScriptsSequentially = async () => {
          for (const url of scriptUrls) {
            if (isCancelled) break;
    
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = url;
              script.onload = resolve;
              script.onerror = reject;
              document.body.appendChild(script);
            });
          }
        };
    
        loadScriptsSequentially();
    
        return () => {
          isCancelled = true;
          // Optionally remove scripts if needed
        };
      }, []);
    const [depName, setDepName] = useState('');
       const [depEmail, setDepEmail] = useState('');
       const [depHead, setDepHead] = useState('');
       const [depPhone, setDepPhone] =useState('');
       const [noRooms, setNoRooms] = useState('');
       const [noBeds, setNoBeds] =useState('');
       const [status, setStatus] = useState('');
       const [message, setMessage] = useState('');
    const navigator = useNavigate();

    function handleEnter(e){
      e.preventDefault();
      
      const formData = new FormData();
      
      formData.append("jsonData" , JSON.stringify({
        "dep_name":depName,
        "dep_email":depEmail,
        "dep_head":depHead,
        "dep_Phone":depPhone,
        "no_rooms":noRooms,
        "no_beds":noBeds,
        "status":status,
        "message":message,
      }));
      
      console.log();
      AddDepartmentSer(formData).then((response) =>{
        console.log(response.data);
        navigator("departments-list");
      })

    }
    const [company, setCompany] = useState([]);
        const srcImg="http://localhost:8080/Images/";
        useEffect(() =>{
            const REST_API_BASE_URL = `http://localhost:8080/api/listBooksByUsers`;
            const updateCompany =() => axios.get(REST_API_BASE_URL);
            updateCompany().then((response) => {
                setCompany(response.data);
            }).catch(error =>{
                console.error(error);
            })
        } , [])
  return(   
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Update Company
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            {/* Custom tabs starts */}
            <div className="custom-tabs-container">
              {/* Nav tabs starts */}
              <ul className="nav nav-tabs" id="customTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="tab-oneA" data-bs-toggle="tab" href="#oneA" role="tab" aria-controls="oneA" aria-selected="true">
                    <i className="ri-profile-line" />
                    Basic
                    Details</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-twoA" data-bs-toggle="tab" href="#twoA" role="tab" aria-controls="twoA" aria-selected="false">
                    <i className="ri-alert-line" /> Operational Settings</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-threeA" data-bs-toggle="tab" href="#threeA" role="tab" aria-controls="threeA" aria-selected="false">
                    <i className="ri-bank-card-line" /> Billing & Financials
                    </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-fourA" data-bs-toggle="tab" href="#fourA" role="tab" aria-controls="fourA" aria-selected="false"><i className="ri-lock-password-line" /> Reset
                    Password</a>
                </li>
              </ul>
              {/* Nav tabs ends */}
              {/* Tab content starts */}
              <div className="tab-content h-350">
                <div className="tab-pane fade show active" id="oneA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4">
                  <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Basic Info</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a1">Company Name <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <input type="text" className="form-control" id="a1" placeholder="Company Name" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a2">Company Type <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <input type="text" className="form-control" id="a2" placeholder="e.g. Hospital, Diagnostic Lab" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a3">Registration No /Lisence No <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a3" placeholder="Registration No" />
                        
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="gstno">Gst/ Tax ID<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a4" placeholder="Gst No" name="gstno"/>
                        
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Logo /Branding <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-secure-payment-line" />
                          </span>
                          <input type="file" className="form-control" id="a5" placeholder="Choose file" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Contact & Address Info</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a6">Head Office Address <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-mail-open-line" />
                          </span>
                          
                          <textarea className="form-control" id="a6" placeholder="office Address" rows={2} defaultValue={""} required/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a7">Branch Locations <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a7" placeholder="Branch Locations" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a8">Phone Number</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a8" placeholder="Phone Numbers"/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a9">Email address</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="email" className="form-control" id="a9" placeholder="Email Address"/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a10">Wesbsite Url</label>
                        {/* <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-nft-line" />
                          </span>
                          <select className="form-select" id="a9">
                            <option value={0}>Select</option>
                            <option value={1}>Doctor</option>
                            <option value={2}>Head of the Dept</option>
                          </select>
                        </div> */}
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a10" placeholder="www@example.com"/>
                        </div>

                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a11">Emergency Contact<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a11" placeholder="www@example.com"/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Authorized Personnal</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a1">Primary Contact Person</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <input type="text" className="form-control" id="a12" placeholder="Contact Info" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a13">Designation/Role</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flag-line" />
                          </span>
                          <select className="form-select" id="a13">
                            <option value={0}>Select</option>
                            <option value={1}>Admin</option>
                            <option value={2}>Director</option>
                            
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a13">Contact Info</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <input type="text" className="form-control" id="a13" placeholder="Contact No" />
                        </div>
                      </div>
                    </div>
                   
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="twoA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4 justify-content-center">
                    <div className="col-sm-8 col-12">
                      <div>
                        <h5>Operational Settings</h5>
                        <p>Defines working hours, available departments, offered services, staff structure, supported languages, and currency settings to tailor daily hospital operations efficiently.</p>
                      </div>
                      <div className="list-group w-auto mb-5">
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-phone-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Appointments</h6>
                            <p className="m-0">
                              You can update new appointment notifications here.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n1" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-mail-send-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Prescriptions</h6>
                            <p className="m-0">
                              You can give priscriptions.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n2" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-star-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Bills</h6>
                            <p className="m-0">
                              You can give the bills.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n3" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-radio-2-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Stocks &amp; inventory</h6>
                            <p className="m-0">
                              You can manage stocks and inventories.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n4" />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-macbook-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>OPD</h6>
                            <p className="m-0">
                              Enable OPD editions facilities.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n5" />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-mail-send-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>IPD</h6>
                            <p className="m-0">
                              Enable IPD facilities.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n6" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-chat-1-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Pathology</h6>
                            <p className="m-0">
                              Enable pathologies sevices.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n7" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-emoji-sticker-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Blood Tests</h6>
                            <p className="m-0">
                              Enable blood test services.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="threeA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4">
                    <div className="col-12">
                      <div className="table-outer mb-3">
                        <div className="table-responsive">
                          <table className="table truncate align-middle m-0">
                            <thead>
                              <tr>
                                <th>Bank Name</th>
                                <th>Card Number</th>
                                <th>Card type</th>
                                <th>Expiry Date</th>
                                <th>Credit Balance</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Discover It Cash Back</td>
                                <td>
                                  <span className="badge bg-primary text-white">0000 0000 0000 0000</span>
                                </td>
                                <td>Visa</td>
                                <td>20/10/2026</td>
                                <td>$100000</td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Capital One Quicksilver Card</td>
                                <td>
                                  <span className="badge bg-success text-white">0000 0000 0000 0000</span>
                                </td>
                                <td>Master</td>
                                <td>02/24/2028</td>
                                <td>$150000</td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive2" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Bank of America Rewards Card</td>
                                <td>
                                  <span className="badge bg-warning text-white">0000 0000 0000 0000</span>
                                </td>
                                <td>Visa</td>
                                <td>05/09/2028</td>
                                <td>$50000</td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive3" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Chase Freedom Unlimited</td>
                                <td>
                                  <span className="badge bg-danger text-white">0000 0000 0000 0000</span>
                                </td>
                                <td>Discover</td>
                                <td>08/20/2027</td>
                                <td>$100000</td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive4" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Blue Cash Everyday Card</td>
                                <td>
                                  <span className="badge bg-dark text-white">0000 0000 0000 0000</span>
                                </td>
                                <td>Visa</td>
                                <td>24/10/2029</td>
                                <td>$90000</td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive5" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Wells Fargo Active Card</td>
                                <td>
                                  <span className="badge bg-info text-white">0000 0000 0000 0000</span>
                                </td>
                                <td>Visa</td>
                                <td>25/05/2030</td>
                                <td>$75000</td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive6" />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="fourA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row justify-content-center">
                    <div className="col-sm-4 col-12">
                      <div className="card border mb-3">
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="currentPwd">Current password <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="password" id="currentPwd" placeholder="Enter Current password" className="form-control" />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-line text-black" />
                              </button>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="newPwd">New password <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="password" id="newPwd" className="form-control" placeholder="Your password must be 8-20 characters long." />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-line text-black" />
                              </button>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="confNewPwd">Confirm new password <span className="text-danger">*</span></label>
                            <div className="input-group">
                              <input type="password" id="confNewPwd" placeholder="Confirm new password" className="form-control" />
                              <button className="btn btn-outline-secondary" type="button">
                                <i className="ri-eye-off-line text-black" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
              </div>
              {/* Tab content ends */}
            </div>
            {/* Custom tabs ends */}
            {/* Buttons starts */}
            <div className="d-flex gap-2 justify-content-end">
              <button type="button" className="btn btn-secondary">
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Update
              </button>
            </div>
            {/* Buttons ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>


  );
}
export default UpdateCompany;




